/**
 * File create a web socket interface to replace the http calls
 */

let socket;
const waitingQueue = [];
let onMessageCallback = null;
const READY_STATE = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

// setup the callback to be called on message
export function setMessageCallback(callback) {
  // TODO: add ability to handle callback for multiple actions
  // onMessageCallbacks[name] = callback;
  onMessageCallback = callback;
}

// send the message to the socket and handle the connecting state
export function send(message) {
  switch (socket.readyState) {
    case READY_STATE.OPEN:
      socket.send(JSON.stringify(message));
      break;
    default:
      // if any other state than open, push to the queue and let the socket get ready
      waitingQueue.push(message);
  }
}


// once the connection is open send all the messages in the queue
function onopen() {
  while (waitingQueue.length) {
    const message = waitingQueue.shift();
    socket.send(JSON.stringify(message));
  }
}

function onmessage(response) {
  // const data = JSON.parse(response.data);
  // TODO: handle case when multiple hander are possbile
  if (typeof onMessageCallback === 'function') {
    onMessageCallback(response);
  }
}

function onerror(response) {
  /* eslint no-console: 0 */
  console.error('Socket Error', response);
}

// initWebSocket - create a websockets, attaches the handlers
function initWebSocket() {
  socket = new WebSocket(WS_URL);
  socket.onopen = onopen;
  socket.onmessage = onmessage;
  socket.onclose = initWebSocket;
  socket.onerror = onerror;
}

initWebSocket();



// WEBPACK FOOTER //
// ./src/api/socket.js